export default __webpack_public_path__ + "static/media/118.4bfb4654.webp";